import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import LinkWrapper from "@/components/linkWrapper";
import MediaWrapper from "@/components/mediaWrapper";
import MarkdownWrapper from "@/components/markdownWrapper";

export const query = graphql`
  fragment TestimonialWithBackgroundImageData on StrapiComponentTestimonialWithBackgroundImage {
    testimonial {
      name
      jobTitle
      text
      image {
        ...StrapiMediaSubquery
      }
      companyLogo {
        ...StrapiSharedLink
      }
    }
  }
`;

function WithBackgroundImage({ data }) {
  if (!data) {
    return <template />;
  }
  return (
    <div className="bg-background-white py-16 lg:py-24">
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-xl bg-background-primary px-8 py-24 shadow-2xl lg:grid lg:grid-cols-2 lg:gap-x-8 lg:px-16">
          <div className="absolute inset-0 opacity-50 mix-blend-multiply saturate-0 filter">
            {data.testimonial.image && (
              <MediaWrapper
                media={data.testimonial.image}
                divClassName="w-full h-full"
              />
            )}
          </div>
          <div className="relative lg:col-span-1">
            {(data.testimonial?.companyLogo?.overwriteIcon ||
              data.testimonial?.companyLogo?.link?.icon) && (
              <LinkWrapper
                to={data.testimonial?.companyLogo?.link?.url}
                className="inline-flex"
              >
                <MediaWrapper
                  media={
                    data.testimonial.companyLogo.overwriteIcon ||
                    data.testimonial.companyLogo.link.icon
                  }
                  divClassName="h-12 w-auto"
                  objectFit="contain"
                />
              </LinkWrapper>
            )}
            <blockquote className="mt-6 text-text-white">
              {data.testimonial.text && (
                <MarkdownWrapper
                  text={data.testimonial.text}
                  markdownClassName="text-xl font-medium sm:text-2xl"
                  replaceParagraph={false}
                />
              )}
              <footer className="mt-6">
                <p className="flex flex-col font-medium">
                  {data.testimonial.name && (
                    <span>{data.testimonial.name}</span>
                  )}
                  {data.testimonial.jobTitle && (
                    <span>
                      <MarkdownWrapper text={data.testimonial.jobTitle} />
                    </span>
                  )}
                </p>
              </footer>
            </blockquote>
          </div>
        </div>
      </div>
    </div>
  );
}

WithBackgroundImage.propTypes = {
  data: PropTypes.object,
};

export default WithBackgroundImage;
